import React from 'react'

import Viewer360 from './../viewer360.Component'

import HeaderDesktop from './UI/header.Component'
import SocialMedia from './UI/socialMedia.Component'
import SidebarDesktop from './UI/sidebar.Component'
import BikeBarDesktop from './UI/bikebar.Component'
import GalleryBar from './UI/galleryBar.component'
import FullGallery from './UI/fullGallery.component'
import BikeView from './viewer3D/bikeView.component'
import Ficha from './UI/fichaTecnica.component'
import FullFicha from './UI/fullFicha.component'
import OpenBullet from './UI/openBullet.component'
import Form from './UI/form.component'
import Redirection from './UI/redirection.Component'

interface Props{
    handleToogleMenu: any
    isMenuOpened: boolean
    isFullScreen:boolean
    isMuted: boolean
    handleFullScreen: any
    handleAudio: any
    handleFamilyBtnClick: any
    handleBackBtn: any
    isFamilias: boolean
    isFamiliaSelected: boolean
    selectedBikeFamily: any
    handleBike: any,
    selectedBike: any
    selectedIndividualBike: boolean,
    currentPanorama: string,
    currentScene: any,
    handlePanoUpdate: any,
    handleOpenMultimedia: any,
    handleOpenSpin: any,
    handleOpenFichaTecnica: any,
    handleOpenFormulario: any,
    isMultimediaOpened: boolean,
    isSpinOpened: boolean,
    isFichaOpened: boolean,
    isFormularioOpened: boolean,
    handleOpenImage: any,
    isGalleryOpened: boolean,
    currentImage: number,
    currentColor: string,
    currentSet: any,
    currentColorsArray: any,
    currentColorIndex: number,
    handleChangeColors: any,
    handleCloseSpin: any,
    isFullFichaOpened: boolean,
    handleFullFicha: any,
    isMobile: boolean,
    handleMotoMes: any,
    handleOpenBullet: any,
    currentBulletImage: string,
    currentBulletText: string,
    openBullet: boolean,
    openRedirectionBar: boolean
    handleOpenRedirection: any
} 

interface State{
    changeView: boolean
}

class Main360Desktop extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {
            changeView: true
        }
    }

    componentDidUpdate(prevProps: any){
        if(this.props.isMobile !== prevProps.isMobile){
            this.setState({
                changeView: false
            }, () => {
                this.setState({
                    changeView: true
                })
            })
        }
    }


    render(){
        return(
            <div className='main-screen-360-component'>
                <Viewer360
                    currentPanorama = {this.props.currentPanorama}
                    currentScene = {this.props.currentScene}
                    handlePanoUpdate = {this.props.handlePanoUpdate}
                    handleOpenBullet = {this.props.handleOpenBullet}
                />
                {
                    this.state.changeView ?
                    <BikeView
                        isSpinOpened = {this.props.isSpinOpened}
                        selectedBike = {this.props.selectedBike}
                        currentColor = {this.props.currentColor}
                        currentSet = {this.props.currentSet}
                        currentColorsArray = {this.props.currentColorsArray}
                        currentColorIndex = {this.props.currentColorIndex}
                        handleChangeColors = {this.props.handleChangeColors}
                        handleCloseSpin = {this.props.handleCloseSpin} 
                    />:null
                }
                <BikeBarDesktop 
                    selectedBike={this.props.selectedBike}
                    selectedIndividualBike={this.props.selectedIndividualBike}
                    handleOpenMultimedia = {this.props.handleOpenMultimedia}
                    handleOpenSpin = {this.props.handleOpenSpin}
                    handleOpenFichaTecnica = {this.props.handleOpenFichaTecnica}
                    handleOpenFormulario = {this.props.handleOpenFormulario}
                    isMultimediaOpened = {this.props.isMultimediaOpened}
                    isSpinOpened = {this.props.isSpinOpened}
                    isFichaOpened = {this.props.isFichaOpened}
                    isFormularioOpened = {this.props.isFormularioOpened}
                />
                <SidebarDesktop 
                    isMenuOpened = {this.props.isMenuOpened}
                    handleFamilyBtnClick={this.props.handleFamilyBtnClick}
                    handleBackBtn={this.props.handleBackBtn}
                    isFamilias={this.props.isFamilias}
                    isFamiliaSelected={this.props.isFamiliaSelected}
                    selectedBikeFamily={this.props.selectedBikeFamily}
                    handleBike = {this.props.handleBike}
                />
                <GalleryBar
                    isMultimediaOpened = {this.props.isMultimediaOpened}
                    selectedBike={this.props.selectedBike}
                    handleOpenMultimedia = {this.props.handleOpenMultimedia}
                    handleOpenImage = {this.props.handleOpenImage}
                />
                <FullGallery
                    isGalleryOpened = {this.props.isGalleryOpened}
                    currentImage = {this.props.currentImage}
                    selectedBike = {this.props.selectedBike}
                    handleOpenImage = {this.props.handleOpenImage}
                />
                <Ficha 
                    isFichaOpened = {this.props.isFichaOpened}
                    selectedBike = {this.props.selectedBike}
                    handleOpenFichaTecnica = {this.props.handleOpenFichaTecnica}
                    handleOpenOnline = {this.props.handleFullFicha}
                />
                <FullFicha 
                    isFichaFullOpened = {this.props.isFullFichaOpened}
                    selectedBike = {this.props.selectedBike}
                />
                <Form
                    isFormularioOpened = {this.props.isFormularioOpened}
                    handleOpenFormulario = {this.props.handleOpenFormulario}
                    selectedBike = {this.props.selectedBike}
                />
                <OpenBullet
                    openBullet = {this.props.openBullet}
                    currentBulletImage = {this.props.currentBulletImage}
                    currentBulletText = {this.props.currentBulletText}
                    handleOpenBullet = {this.props.handleOpenBullet}
                />
                <HeaderDesktop
                    handleToogleMenu = {this.props.handleToogleMenu}
                    isMenuOpened = {this.props.isMenuOpened}
                    isFullScreen = {this.props.isFullScreen}
                    isMuted = {this.props.isMuted}
                    handleFullScreen = {this.props.handleFullScreen}
                    handleAudio = {this.props.handleAudio}
                    handleMotoMes = {this.props.handleMotoMes}
                />
                <Redirection
                    handleOpenRedirection = {this.props.handleOpenRedirection}
                    openRedirectionBar = {this.props.openRedirectionBar}
                    selectedBike = {this.props.selectedBike}
                />
                <SocialMedia/>
            </div>
        )
    }
}

export default Main360Desktop